import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';


class UserUploadedBooksView extends React.Component {
  constructor(props) {
    super(props);
    const { userId } = props.match.params;

    this.pageLimit = 24;
    this.breadcrumbs = [];

    this.state = {
      userId,
      pageNumber: 1,
      lastPageNumber: 0,
      books: null,
      totalBookCount: null,
      header: {
        title: 'Загрузки',
        bookCount: null,
        description: '',
        image: null,
        backLink: null,
      },
    };

    this.props.SeoActions.setData({
      title: 'Загрузки в моих книгах в электронной библиотеке MyBook',
    });
  }

  componentDidMount() {
    this.fetchBookList();
  }

  componentDidUpdate(nextProps) {
    const newUserId = nextProps.match.params.userId;
    if (newUserId && newUserId !== this.state.userId) {
      const newState = {
        userId: newUserId,
      };
      this.setState(
        { ...this.defaultState, ...newState },
        () => this.fetchBookList(),
      );
    }
  }

  fetchBookList(pageNumber = 1) {
    const offset = pageNumber * this.pageLimit - this.pageLimit;
    const url = `/api/upload/?user=${this.state.userId}&limit=${this.pageLimit}&offset=${offset}`;
    fetchQuery(url)
      .then(({ data }) => {
        this.setState({
          header: {
            ...this.state.header,
            ...{ bookCount: data.meta.total_count },
          },
        },
        () => this.paginateBookList(this.prepareUserUploadedBooks(data.objects), data.meta.total_count));
      });
  }

  prepareUserUploadedBooks(objects) {
    // return book instances, filter out unprocessed books
    return objects
      .filter((uploadedBook) => !!uploadedBook.book)
      .map((uploadedBook) => uploadedBook.book);
  }

  changePage(newPageNumber) {
    window.scrollTo(0, 0);

    this.setState({
      pageNumber: newPageNumber,
      books: null,
    }, () => this.fetchBookList(newPageNumber));
  }

  paginateBookList(bookList, totalCount) {
    const lastPageNumber = Math.ceil(totalCount / this.pageLimit);

    this.setState({
      books: bookList,
      lastPageNumber: lastPageNumber,
      totalBookCount: totalCount,
    });
  }

  render() {
    const { header, books, pageNumber, lastPageNumber, totalBookCount } = this.state;

    return (
      <div className="section">
        {this.breadcrumbs.length > 0 && <BreadCrumbs links={this.breadcrumbs} />}
        <CatalogHeader {...header} />
        {get(books, 'length') && totalBookCount !== null
          ? <BookList books={books} />
          : <BookList books={[...Array(5)]} />
        }
        {lastPageNumber > 1 && (
          <ContextPagination
            onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
            currentPage={pageNumber}
            lastPage={lastPageNumber} />
        )}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(UserUploadedBooksView);
